import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ConfigProvider, App as AntApp } from 'antd';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';

import App from './App';
import { store } from './store';
import { setupStore } from './store/setup';
import { antdTheme } from './config/theme';
import { AntdStaticProvider } from './utils/antd';
import './styles/global.css';

// Configure dayjs plugins
dayjs.extend(relativeTime);
dayjs.extend(updateLocale);

// Setup store for axios instance
setupStore();

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
    mutations: {
      retry: 0,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ConfigProvider theme={antdTheme}>
            <AntApp message={{ maxCount: 1, duration: 2, top: 80 }}>
              <AntdStaticProvider />
              <App />
            </AntApp>
          </ConfigProvider>
        </BrowserRouter>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);
